<!-- 数据树表格 -->
<template>
<div class="tree_template">
  <div v-show="!searchHidden&&searchOption.column.length!==0">
    <m-form ref="searchForm" v-model="query" :option="searchOption" @submit="searchChange" @reset="searchReset">
      <slot name="searchSlot" :query="query"></slot>
    </m-form>
  </div>
  <!-- 功能按钮和辅助按钮区域区域 -->
  <el-row class="width-p100 ds-fx flex-direction-row align-items-center justify-content-start flex-wrap mb-none">
    <!-- 功能按钮区域 -->
    <el-col span="12" class="mb-xxs ds-fx flex-direction-row justify-content-start align-items-center">
      <el-button v-if="allOption.exportBtn!==false" icon="el-icon-download" type="primary" size="mini" @click="excelClick">导出</el-button>
      <!-- <el-button icon="el-icon-printer" type="primary" size="mini" @click="printDivClick">打印</el-button> -->
      <el-button v-if="allOption.addBtn" icon="el-icon-plus" type="success" size="mini" @click="addClick">新增</el-button>
      <el-button v-for="(item,index) in topButton" :key="index" :type="item.color" :title="item.btnHelp" :icon="item.icon" size="mini" @click="clickButton(item)" style="margin-left: 10px;">{{item.btnName}}</el-button>
      <data-import v-if="allOption.importBtn===true" style="margin: 0 10px;" :op='{opid:colObj.opId||"",dataClass:colObj.dataClass||"",dwId:colObj.dwId||""}' :uploadObj="colObj.dataImportUploadObj" :column="allOption.column" :colObj="colObj" :importTemp="colObj.importTemp" :interface="colObj.interface">
        <template slot="importTemp">
          <slot name="importTemp"></slot>
        </template>
      </data-import>
    </el-col>
    <!-- 辅助按钮区域 -->
    <el-col span="12" class="mb-xxs ds-fx flex-direction-row justify-content-end align-items-center">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button icon="el-icon-refresh" size="mini" circle @click="onLoad"></el-button>
      </el-tooltip>
      <el-tooltip v-if="allOption.searchBtn&&searchOption.column.length!==0" class="item" effect="dark" content="搜索显隐" placement="top">
        <el-button :icon="searchHidden?'el-icon-zoom-in':'el-icon-zoom-out'" size="mini" circle @click="searchHidden=!searchHidden"></el-button>
      </el-tooltip>
      <el-tooltip v-if="allOption.columnBtn" class="item" effect="dark" content="显隐" placement="top">
        <el-button icon="el-icon-s-operation" size="mini" circle @click="columnCtrl=true"></el-button>
      </el-tooltip>
      <el-tooltip v-if="allOption.filterBtn" class="item" effect="dark" content="高级检索" placement="top">
        <el-button icon="iconfont icon-canshu" size="mini" circle @click="filterCtrl=true"></el-button>
      </el-tooltip>
    </el-col>
  </el-row>
  <div id="printDiv" v-loading="loading">
    <ux-grid
      v-bind="$attrs"
      :height='tableHeightFn()'
      show-overflow
      highlight-hover-row
      row-key
      row-id="ID"
      rowId="ID"
      ref="plxTree"
      border="inner"
      :data="data"
      :checkbox-config="{labelField: 'name'}"
      :tree-config="allOption.extendTreeType!=1?{accordion:true,line:true,iconOpen:'el-icon-minus',iconClose:'el-icon-plus',lazy: true,reserve:true,
      children:'CHILDREN',hasChild:'HAS_CHILDREN',loadMethod:loadChildrenMethod}
      :{children:'CHILDREN_LIST',hasChild:'HAS_CHILDREN',line: true,expandAll:true,iconOpen:'el-icon-minus',iconClose:'el-icon-plus',}"
    >
      <ux-table-column tree-node :min-width="allOption.column[0]?allOption.column[0].width||400:400" resizable :title="allOption.column[0]?allOption.column[0].label:''" :type="allOption.selection?'checkbox':''">
        <!--自定义展开部分的内容-->
        <template v-slot="{ row }">
          <span>
            <template v-if="row.HAS_CHILDREN">
              <i style="margin-left: 8px" :class="$refs.plxTree.isTreeExpandByRow(row)?'el-icon-folder-opened':'el-icon-folder'"></i>
            </template>
            <template v-else>
              <i style="margin-left: 8px" class="el-icon-document"></i>
            </template>
            <span :class='{"url":allOption.column[0]&&!!allOption.column[0].linkType}' @click="urlClick(allOption.column[0]&&allOption.column[0],row)">{{row[`$${allOption.column[0]&&allOption.column[0].prop}`]||row[allOption.column[0]&&allOption.column[0].prop]}}</span>
          </span>
        </template>
      </ux-table-column>
      <template v-for="(item,index) in allOption.column">
        <ux-table-column
          v-if="hidColumnData.indexOf(item.prop) === -1&&index!==0"
          :align="item.align || 'center'"
          :sortable="item.sortable"
          :show-overflow="item.overHidden"
          :key="item.ID"
          resizable
          :field="item.prop"
          :title="item.label"
          :fixed="(item.fixed?'left':false)"
          :min-width="item.width || 80">
          <template slot-scope="scope">
            <slot v-if="item.type=='switch'&&item.value" :name="item.prop" v-bind='{scope,item}'>
              <el-switch v-model="scope.row[item.prop]" :disabled="!allOption.editBtn" :active-value="item.dicData[0].value" :inactive-value="item.dicData[1].value" :active-color='item.activeColor?item.activeColor:filterArr(item.dicData,"value",scope.row[item.prop],"color")' :inactive-color='item.inactiveColor?item.inactiveColor:filterArr(item.dicData,"value",scope.row[item.prop],"color")'  @change="switchClick(scope.row,item.prop,scope.row[item.prop])"></el-switch>
            </slot>
            <slot v-else-if="item.type=='color'" :name="item.prop" v-bind='{scope,item}'>
              <div :style='"width:28px;height:28px;border-radius:6px;margin:auto;display:block;background:"+scope.row[item.prop]'></div>
            </slot>
            <slot v-else-if="item.type=='code'" :name="item.prop" v-bind='{scope,item}'>
              <span :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)" v-html="scope.row[item.prop]"></span>
            </slot>
            <slot v-else-if="item.dicData.length>0" :name="item.prop" v-bind='{scope,item}'>
              <span :style='{color:filterArr(item.dicData,"value",scope.row[item.prop],"color")}'
                    :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)">
                <i v-if="item.urlType==='8'" :class='filterArr(item.dicData,"value",scope.row[item.prop],"icon")'></i>
                <span v-text="item.urlType==='2'?filterArrs(item.dicData,'value',scope.row[item.prop],'label'):''"></span>
              </span>
            </slot>
            <slot v-else-if="filterArrBool(colObj.col||[],item.prop)" :name="item.key" v-bind='{scope,item}'>
              <div v-for="(item1,index) in colObj.col||[]" :key="index">
                <!-- 颜色 -->
                <span v-if="item1.type==='color'&&item1.key==item.prop" :class="{'hover':item1.method}" :style='{"color":item1.color?item1.color:filterArr(item.dicData,"value",scope.row[item1.key],"color")}' @click="colorClick(item1.method,scope.row)" :key="index">{{filterArr(item.dicData,"value",scope.row[item1.show],"label")}}</span>
                <!-- 开关 -->
                <el-switch v-else-if="item1.type==='switch'&&item1.key==item.prop" :disabled="!allOption.editBtn" v-model="scope.row[item.key]" :active-value="item1.activeValue" :inactive-value="item1.inactiveValue" :active-color='item1.activeColor?item1.activeColor:filterArr(dicData[item1.key+"Data"],"value",scope.row[item1.key],"color")' :inactive-color='item1.inactiveColor?item1.inactiveColor:filterArr(dicData[item1.key+"Data"],"value",scope.row[item1.key],"color")'  @change="switchClick(scope.row,item1.key,scope.row[item1.key])" :key="index"></el-switch>
              </div>
            </slot>
            <slot v-else-if="item.type=='selectDown'||item.type=='tableSelect'" :name="item.prop" v-bind='{scope,item}'>
              <span :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)">{{scope.row[`$${item.prop}`]||scope.row[item.prop]}}</span>
            </slot>
            <slot v-else-if="item.type=='datetime'||item.type=='date'" :name="item.prop">
              <span :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)" v-text="dateFormat(scope.row[item.prop],item.format)"></span>
            </slot>
            <slot v-else :name="item.prop" v-bind='{scope,item}'>
              <span :class='{"url":item.linkType&&item.linkType!=0}' @click="urlClick(item,scope.row)">{{scope.row[`$${item.prop}`]||scope.row[item.prop]}}</span>
            </slot>
          </template>
        </ux-table-column>
      </template>
      <ux-table-column v-if="allOption.menu" :align="allOption.menuAlign||'center'" :min-width="allOption.menuWidth"
        show-overflow title="操作" resizable fixed="right">
        <template slot-scope="scope">
          <!-- <slot name="menuLeft" v-bind="{scope,btnLoading}"></slot> -->
          <el-button v-if="allOption.viewBtn" icon="el-icon-view" type="text" size="mini" @click="viewClick(scope.row)">查看</el-button>
          <el-button v-if="allOption.editBtn" icon="el-icon-edit" type="text" size="mini" @click="editClick(scope.row)">修改</el-button>
          <el-button v-if="allOption.delBtn" icon="el-icon-delete" type="text" size="mini" @click="rowDel(scope.row)">删除</el-button>
          <el-button v-if="allOption.copyBtn" icon="el-icon-document-copy" type="text" size="mini" @click="rowCopy(scope.row)">复制</el-button>
          <el-button v-if="allOption.addPeerBtn" icon="el-icon-plus" type="text" size="mini" @click="rowAddPeer(scope.row)">新增同级</el-button>
          <el-button v-if="allOption.addSubBtn" icon="el-icon-bottom" type="text" size="mini" @click="rowAddSub(scope.row)">新增下级</el-button>
          <el-button v-for="(item) in scope.row.OK_BUTTON" :key="item.id" type="text" :icon="item.icon" :title="item.btnHelp" size="mini" @click="clickButton(item,scope.row)">{{item.btnName}}</el-button>
          <!-- <slot name="menuRight" v-bind="{scope,btnLoading}"></slot> -->
          <!-- <el-dropdown trigger="click" @command="handleCommand($event,scope.row)">
            <span class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="allOption.viewBtn" icon="el-icon-view" command="viewBtn">查看</el-dropdown-item>
              <el-dropdown-item v-if="allOption.editBtn" icon="el-icon-edit" command="editBtn">修改</el-dropdown-item>
              <el-dropdown-item v-if="allOption.delBtn" icon="el-icon-delete" command="delBtn">删除</el-dropdown-item>
              <el-dropdown-item v-if="allOption.copyBtn" icon="el-icon-document-copy" command="copyBtn">复制</el-dropdown-item>
              <el-dropdown-item v-if="allOption.addPeerBtn" icon="el-icon-plus" command="addPeerBtn">新增同级</el-dropdown-item>
              <el-dropdown-item v-if="allOption.addSubBtn" icon="el-icon-bottom" command="addSubBtn">新增下级</el-dropdown-item>
              <el-dropdown-item v-for="(item) in scope.row.OK_BUTTON" :key="item.id" :icon="item.icon" :command="item.btnType">{{item.btnName}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </template>
      </ux-table-column>
    </ux-grid>
  </div>
  <div class="ux-page" v-if="paging">
    <footer>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </footer>
  </div>
  <el-dialog :visible.sync="selector" :append-to-body="true" width="90%" top="1vh" :title="select.searchslottitle+(select.multiple?' (多选)':' (单选)')" @closed="selectorTemplate=false" :close-on-click-modal="false" v-dialogdrag>
    <TreeTableSelector v-if="selectorTemplate&&treeSelector" ref="TreeSelector" :select="select" @listenEvent="fn"></TreeTableSelector>
    <Selector v-if="selectorTemplate&&!treeSelector" ref="ConSelector" :select="select" @listenEvent="fn"></Selector>
  </el-dialog>
  <el-dialog :visible.sync="batchSelector" :append-to-body="true" width="90%" top="1vh" :title="batch.title" :close-on-click-modal="false" @closed="batchSelectorTemp=false" v-dialogdrag>
    <Selector v-if="batchSelectorTemp" ref="batchConSelector" :select="batch" @listenEvent="batchfn"></Selector>
  </el-dialog>
  <el-dialog :visible.sync="addDialog" :append-to-body="true" width="90%" title="新增" :close-on-click-modal="false" v-dialogdrag>
    <m-form v-if="addDialog" class="dialgForm" ref="addForm" v-model="addForm" :option="formOption" @submit="rowSave" @cancel="addDialog=false">
      <template slot="tip">
        <div class="tableTip">
          <p v-html="extendedProp.formTip"></p>
        </div>
      </template>
      <template slot="btnLeft">
        <el-button v-if="addType=='peer'||addType=='sub'" @click="saveAndAdd" icon="el-icon-push" type="primary" size="mini" :loading="saveAndAddLoading">保存并新增本级</el-button>
      </template>
    </m-form>
  </el-dialog>
  <el-dialog :visible.sync="copyDialog" :append-to-body="true" width="90%" title="新增" :close-on-click-modal="false" v-dialogdrag>
    <m-form v-if="copyDialog" class="dialgForm" ref="copyForm" v-model="form" :option="formOption" @submit="rowSave" @cancel="copyDialog=false">
      <template slot="tip">
        <div class="tableTip">
          <p v-html="extendedProp.formTip"></p>
        </div>
      </template>
    </m-form>
  </el-dialog>
  <el-dialog :visible.sync="editDialog" :append-to-body="true" width="90%" title="修改" :close-on-click-modal="false" v-dialogdrag>
    <m-form v-if="editDialog" class="dialgForm" ref="editForm" v-model="form" :option="formOption" @submit="rowUpdate" @cancel="editDialog=false">
      <template slot="tip">
        <div class="tableTip">
          <p v-html="extendedProp.formTip"></p>
        </div>
      </template>
    </m-form>
  </el-dialog>
  <el-dialog :visible.sync="viewDialog" :append-to-body="true" width="90%" title="查看" :close-on-click-modal="false" v-dialogdrag>
    <m-form v-if="viewDialog" class="dialgForm" ref="viewForm" v-model="form" :option="formOption" @cancel="viewDialog=false">
      <template slot="tip">
        <div class="tableTip">
          <p v-html="extendedProp.formTip"></p>
        </div>
      </template>
    </m-form>
  </el-dialog>
  <!-- 列显隐弹窗 -->
  <el-drawer title="列显隐" :visible.sync="columnCtrl" direction="rtl" :append-to-body="true" size="50%">
    <el-transfer
      class="height-p100 ds-fx flex-direction-row center"
      filterable
      :titles="['显示', '隐藏']"
      filter-placeholder="请输入列名称"
      v-model="hidColumnData"
      :data="allOption.column">
    </el-transfer>
  </el-drawer>
  <!-- 过滤弹窗 -->
  <filter-dialog :visible.sync="filterCtrl" @submit="filterSubmit" :column="this.allOption.column" :colObj="colObj"></filter-dialog>
</div>
</template>
<script>
import {mapGetters} from "vuex";
import {configure,addShow,getShow,updateShow,deleteShow,exportExcel,post} from "@/api/table/table";
import Selector from '@/components/table/selectorc';
import FilterDialog from '@/components/table/template/filterDialog';
import DataImport from '@/components/table/template/dataImport';
import TreeTableSelector from '@/components/table/treeTableSelector';
import MForm from '@/components/table/template/mform';
import iconList from "@/config/iconList";
import {urlToObj,parseParams,getObjType,strByReg,objFilterEmpty} from "@/util/util";
import {dateFormat} from '@/util/date';
export default {
components: {
  Selector,
  TreeTableSelector,
  MForm,
  FilterDialog,
  DataImport,
},
props:{loadObj:Object,filterObj:Object,
  colObj:{
    type:Object,
  },
  paging:{  // 分页器显示或者隐藏
    type:Boolean,
    default:true,
  },
  option:Object,dataObj:Object},
/**
dataObj 获取数据接口配置 暂时只支持不懒加载
 url 接口路径 params 接口参数
**/
data() {
  return {
    addType:"",
    loading:true,
    addDialog:false,
    treeSelector:false,  // 树形选择器
    saveAndAddLoading:false,
    editDialog:false,
    viewDialog:false,
    copyDialog:false,
    batchSelector:false,
    batchSelectorTemp:false,
    searchHidden:false,
    columnCtrl:false, // 显隐窗口
    viewOption:{},
    batch:{},
    page: {
      pageSize: 20,
      currentPage: 1,
      total: 0,
      pageSizes:[5, 10, 20, 50, 100, 200, 500, 1000]
    },
    query: {}, //查询
    form: {},   // 提交表单
    addForm: {},   // 提交表单
    customSearch:[], //自定义搜索
    avueOption:{
      dataType:"string",
      stripe:true,
      addBtn:false,
      editBtn:false,
      delBtn:false,
      viewBtn:false,
      printBtn:false,
      excelBtn:false,
      searchBtn:true,
      refreshBtn:true,
      filterBtn:false,
    },
    selector:false, //选择器
    selectorTemplate:false, //选择器
    select:{
      searchslottitle:"选择器",
      searchslotId:"", //搜索选择器的id
      searchslotkey:{},  //搜索选择器的key
      searchslotType:"", //选择器的类型
      filterWhere:"", //选择器过滤
    },
    data: [],
    extendedProp:{},
    sonQuery:{},   //子表对象
    column:[],
    dicData:{}, //存字典数据
    buttonOption:{}, // 配置button旁边的配置
    topButton:[], // 顶部自定义按钮
    formOption:{}, //form配置
    searchList:[],  //搜索list
    sortOrder:"", // 记录排序状态
    hidColumnData: [],//隐藏的列数据
    filterCtrl: false,//过滤器控制
    filterData: [],//过滤条件数据
    filterMethods: ['=','≠','like','≥','≤','∈'],//过滤方法
    filterIndex: "",//为了配合过滤器调用选择的器的时候回填数据，记录被点击的过滤条件
    selectorProp:"",
    slider:[], // 需要转为数值的数据
  };
},
computed: {
  ...mapGetters(["userInfo"]),
  allOption:function(){
    return {
      ...this.buttonOption,
      ...this.avueOption,
      ...this.option,
      ...this.extendedProp,
      ...this.loadObj,
      column:this.column,
    }
  },
  searchOption:function () {
    let obj={};
    if(this.extendedProp.keyWordSearch==='true'){
      let arr=[];
      let labelArr = this.extendedProp.keyWordLabel.split(",");
      for (let i = 0; i < this.extendedProp.keyWordProps.split(",").length; i++) {
        const element = this.extendedProp.keyWordProps.split(",")[i];
        arr.push({value:element,label:labelArr[i]})
      }
      obj.keyWordSearch=true;
      obj.keyWordProps=arr;
    }
    return{
      labelWidth:0,
      menuSpan:4,
      enter:true,
      noLabel:true,
      submitText: '搜索',
      submitIcon: 'el-icon-search',
      column:this.searchList,
      ...obj,
    }
  },
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  // 日期转换
  dateFormat(date,format){
    if(!date) return "";
    return dateFormat(new Date(date),format);
  },
  // 转换为大写
  getUpperCaseClick(prop,value,obj){
    if(prop){
      for (let i = 0; i < prop.split(';').length; i++) {
        const element = prop.split(';')[i];
        if(element.split(':')[1]==='EMPTY'){
          this[obj][element.split(':')[0]]="";
        }else{
          getUpperCase(this.$qs.stringify({value:value,type:element.split(':')[1]})).then(res=>{
            this[obj][element.split(':')[0]]=res.data.data.data;
          },err=>{})
        }
      }
    }
  },
  // 懒加载
  loadChildrenMethod({ row }) {
    // 请求后端示例 axios.get本来就是返回一个Promise
    if(this.dataObj){
      return post(this.dataObj.url, this.$qs.stringify({
        runId:this.$route.query.runId,
        current:this.page.currentPage,
        size:this.page.pageSize,
        obj:JSON.stringify(objFilterEmpty({...this.colObj.childObj,[this.extendedProp.parent||'PARENT_ID']:row.ID,...this.sonQuery})),
        extendTreeType:this.allOption.extendTreeType||2,
        opid:this.colObj.opId,
        type:this.colObj.dataClass,
        ...this.loadObj,
        ...this.sort,
        ...this.dataObj.params,
      })).then(res => {
        let records=res.data.data;
        for (let i = 0; i < records.length; i++) {
          records[i].HAS_CHILDREN=JSON.parse(records[i].HAS_CHILDREN);
        }
        return records;
      },err=>{
        this.loading = false;
      });
    }else{
      return getShow(1, 9999,this.$route.query.runId,{
        obj:objFilterEmpty({...this.colObj.childObj,[this.extendedProp.parent||'PARENT_ID']:row[this.colObj.rowId||"ID"],...this.sonQuery}),
        extendTreeType:this.allOption.extendTreeType||2,
        opid:this.colObj.opId,
        type:this.colObj.dataClass,
        ...this.loadObj,
        ...this.sort
      }).then(res => {
        let records=res.data.data.records;
        for (let i = 0; i < records.length; i++) {
          records[i].HAS_CHILDREN=JSON.parse(records[i].HAS_CHILDREN);
        }
        return records;
      },err=>{
        this.loading = false;
      });
    }
  },
  // 链接点击事件
  async urlClick(item,data){
    if(!item.linkType) return;
    let queryObj=item.linkParam?this.urlFn(item.linkParam,data):{};
    let runId=item.linkOpid?await this.getRunIdFn(item.linkOpid):this.$route.query.runId;
    switch (item.linkMethod) {
      case "1":  //  详情
        this.$router.push({
          path:item.linkPath,
          query:{runId:runId,...queryObj},
        })
        break;
      case "2":  //  列表
        this.$router.push({
          path:item.linkPath,
          query:{runId:runId,...queryObj},
        })
        break;
      case "9":  //  外部
        this.$router.push({
          path:"/myiframe/urlPath",
          query:{
            src:parseParams(item.linkPath,{runId:runId,...queryObj})
          },
        })
        break;
      case "10":  //  触发事件
        console.log(item.linkPath+"Click");
        if(item.linkPath=='rowFile'){
          this.rowFile(data);
        }else{
          this.$parent.$parent.$parent.$parent[item.linkPath+"Click"](item,data);
        }
        break;
      default:
        break;
    }
  },
  urlFn(str,data){
    let arr = str.split("&");
    let obj={};
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      obj[element.split("=")[0]]=element.split("=")[1].indexOf("{")===-1?element.split("=")[1]:data[element.split("=")[1].replace(/{|}/g,"")]
    }
    return obj;
  },
  async getRunIdFn(opid){
    if(opid==this.colObj.opId) return this.$route.query.runId;
    return this.userInfo.runId;
  },
  resultFormat(resp){
    if(resp && resp.data) return resp.data.gridResult
  },
  // 过滤数组
  filterArrBool(arr,item){
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      if(element.key==item){
        return true;
      }
    }
    return false;
  },
  // 导出按钮
  excelClick(){
    this.$confirm("确认导出搜索的所有数据？", "提示", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      distinguishCancelAndClose: true,
    }).then(res => {
      if(this.colObj.dataClass!==1&&this.colObj.dataClass){
        this.sonQueryFn();
      }
      let query=this.deepClone(this.query);
      if(query.keySearchSearchValue){
        query.keySearch={
          searchValue:query.keySearchSearchValue,
          searchKey:query.keySearchSearchKey,
          searchType:query.keySearchSearchType,
        }
        delete query.keySearchSearchValue;
        delete query.keySearchSearchKey;
        delete query.keySearchSearchType;
      }
      exportExcel({
        obj:{...query,...this.filterObj,...this.sonQuery},
        isExportAll:1,
        opid:this.allOption.dcopId||this.colObj.opId,
        type:this.allOption.dcdataClass||this.colObj.dataClass,
        runId:this.$route.query.runId,
        ...this.loadObj,
        ...this.sort
      },{
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/octet-stream'
        })
        let fileName = decodeURI(res.headers['content-disposition'].split(';filename')[1].replace(/=|"/g,''));
        let url = window.URL.createObjectURL(blob);//为文件流创建构建下载链接
        let link = document.createElement('a');//创建a标签
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download',fileName||`${this.$route.query.name}.xls`||`${new Date().getTime()}.xls`);//设置a标签的下载动作和下载文件名
        document.body.appendChild(link);
        link.click();//执行下载
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);//释放标签
      })
    }).catch(err => {});
  },
  // 打印按钮
  printDivClick(){
    this.$Print({
      id:'printDiv'
    });
  },
  handleCommand(btnType,row){
    console.log(btnType,row);
    this.clickButton({btnType},row);
  },
  //  行按钮
  clickButton(item,row){
    console.log(item.btnType+"Click");
    switch (item.btnType) {
      case 'delBtn':
        this.rowDel(row);
        break;
      case 'editBtn':
        this.editClick(row);
        break;
      case 'viewBtn':
        this.viewClick(row);
        break;
      case 'copyBtn':
        this.rowCopy(row);
        break;
      case 'addPeerBtn':
        this.rowAddPeer(row);
        break;
      case 'addSubBtn':
        this.rowAddSub(row);
        break;
      default:
        if(row){
          this.$parent.$parent.$parent.$parent[item.btnType+"Click"](item,row);
        }else{
          this.$parent.$parent.$parent.$parent[item.btnType+"Click"](item,this.$refs.plxTree.getCheckboxRecords());
        }
        break;
    }
  },
  // 行删除按钮
  rowDel(row) {
    this.$confirm("确定将选择数据删除?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      deleteShow({
        id:row.ID,
        opid:this.colObj.opId,
        dataClass:this.colObj.dataClass,
        runId:this.$route.query.runId,
        type:"change",
        ...this.filterObj,
        ...this.sonQuery,
      },{
      }).then(() => {
        this.onLoad();
        this.$message.success("操作成功!");;
      },err=>{

      })
    },err=>{});
  },
  filterNode (data, row, rowId) {
    let newData = data.filter(x => x[rowId] !== row[rowId])
    newData.forEach(x => x.children && (x.children = this.filterNode(x.children, row, rowId)))
    return newData
  },
  // 行修改
  editClick(row){
    for (let i = 0; i < this.slider.length; i++) {
      const element = this.slider[i];
      row[element]=Number(row[element]);
    }
    this.form=this.deepClone(row);
    let editList=[];
    for (let i = 0; i < this.allOption.column.length; i++) {
      const element = this.allOption.column[i];
      if(element.editDisplay===true){
        if(element.editDisabled===true){
          element.disabled=true;
        }
        editList.push(element);
      }
    }
    this.formOption={
      submitText: '保存',
      styleType:'blue',
      labelWidth:110,
      column:editList,
      delete:true,
    }
    this.editDialog=true;
  },
  // 行新增同级
  rowAddPeer(row) {
    let addList=[];
    let addform={};
    for (let i = 0; i < this.allOption.column.length; i++) {
      const element = this.allOption.column[i];
      if(element.addDisplay===true){
        if(element.addDisabled===true){
          element.disabled=true;
        }
        addList.push(element);
      }
      if(element.value){
        addform[element.prop]=element.value;
      }
    }
    if(this.colObj.addProp){
      for (let index = 0; index < this.colObj.addProp.length; index++) {
        const ele = this.colObj.addProp[index];
        addform[ele]=row[ele];
      }
    }
    this.addType="peer";
    addform[this.extendedProp.parent||'PARENT_ID']=row[this.extendedProp.parent||'PARENT_ID'];
    this.formOption={
      submitText: '保存',
      styleType:'blue',
      labelWidth:110,
      column:addList,
    }
    this.addForm=this.deepClone(Object.assign(this.addForm,addform));
    this.addDialog=true;
  },
  // 行新增下级
  rowAddSub(row) {
    let addList=[];
    let addform={};
    for (let i = 0; i < this.allOption.column.length; i++) {
      const element = this.allOption.column[i];
      if(element.addDisplay===true){
        if(element.addDisabled===true){
          element.disabled=true;
        }
        addList.push(element);
      }
      if(element.value){
        addform[element.prop]=element.value;
      }
    }
    if(this.colObj.addProp){
      for (let index = 0; index < this.colObj.addProp.length; index++) {
        const ele = this.colObj.addProp[index];
        console.log(row[ele]);
        addform[ele]=Number(row[ele])+1;
      }
    }
    this.addType="sub";
    addform[this.extendedProp.parent||'PARENT_ID']=row[this.extendedProp.child||'ID'];
    this.formOption={
      submitText: '保存',
      styleType:'blue',
      labelWidth:110,
      column:addList,
    }
    this.addForm=this.deepClone(Object.assign(this.addForm,addform));
    this.addDialog=true;
  },
  // 行编辑按钮
  rowUpdate(row,done) {
    let object=row;
    for (const key in object) {
      if (Array.isArray(object[key])) {
        object[key]=object[key].toString();
      }else if(object[key]===true||object[key]===false){
        object[key]=object[key]?1:0;
      }
    }
    updateShow({
        opid:this.colObj.opId,
        dataClass:this.colObj.dataClass,
        data:object,
        runId:this.$route.query.runId,
        ...this.filterObj,
        ...this.sonQuery
    },{
    }).then(() => {
      this.onLoad();
      this.$message.success("操作成功!");
      this.editDialog=false;
      done();
    }, err => {
      this.editDialog=false;
      done();
    });
  },
  // 新增
  addClick(empty){
    if(empty) this.addForm={};
    let addList=[];
    let addform={};
    for (let i = 0; i < this.allOption.column.length; i++) {
      const element = this.allOption.column[i];
      if(element.addDisplay===true){
        if(element.addDisabled===true){
          element.disabled=true;
        }
        addList.push(element);
      }
      if(element.value){
        addform[element.prop]=element.value;
      }
    }
    this.formOption={
      submitText: '保存',
      styleType:'blue',
      labelWidth:110,
      column:addList,
    }
    this.addDialog=true;
    this.addForm=this.deepClone(Object.assign(this.addForm,this.colObj.addForm,addform));
  },
  // 查看
  viewClick(row){
    for (let i = 0; i < this.slider.length; i++) {
      const element = this.slider[i];
      row[element]=Number(row[element]);
    }
    this.form=row;
    this.formOption={
      labelWidth:110,
      detail:true,
      ...this.allOption,
    };
    this.viewDialog=true;
  },
  rowCopy(row){
    for (let i = 0; i < this.slider.length; i++) {
      const element = this.slider[i];
      row[element]=Number(row[element]);
    }
    this.form=this.deepClone(row);
    delete this.form.ID;
    delete this.form.OK_BUTTON;
    // console.log(this.form);
    let copyList=[];
    for (let i = 0; i < this.allOption.column.length; i++) {
      const element = this.allOption.column[i];
      if(element.addDisplay===true){
        if(element.addDisabled===true){
          element.disabled=true;
        }
        copyList.push(element);
      }
    }
    this.formOption={
      submitText: '保存',
      labelWidth:110,
      column:copyList,
    }
    this.copyDialog=true;
  },
  // 顶部添加按钮
  rowSave(row, done, loading) {
    let object=this.deepClone(row);
    delete object.ID;
    delete object.OK_BUTTON;
    for (const key in object) {
      if (Array.isArray(object[key])) {
        object[key]=object[key].toString();
      }
    }
    if(object[this.extendedProp.parent||'PARENT_ID']==""){
      object={...object,...this.filterObj}
    }
    addShow({
      opid:this.colObj.opId,
      dataClass:this.colObj.dataClass,
      data:{...object,...this.colObj.addParams},
      runId:this.$route.query.runId,
      ...this.filterObj,
      ...this.sonQuery
    },{
    }).then(() => {
      this.onLoad();
      this.$message.success("新增成功!");
      done();
      this.$refs.addForm.resetForm();
      this.addDialog=false;
      this.copyDialog=false;
    }, err => {
      done();
    });
  },
  // 保存并且新增本级
  saveAndAdd() {
    this.saveAndAddLoading=true;
    this.$refs.addForm.validate((valid,done) => {
      if (valid) {
        let object=this.deepClone(this.addForm);
        delete object.ID;
        delete object.OK_BUTTON;
        for (const key in object) {
          if (Array.isArray(object[key])) {
            object[key]=object[key].toString();
          }else if(object[key]===true||object[key]===false){
            object[key]=object[key]?1:0;
          }
        }
        addShow({
          opid:this.colObj.opId,
          dataClass:this.colObj.dataClass,
          data:{...object,...this.colObj.addParams},
          runId:this.$route.query.runId,
          ...this.filterObj,
          ...this.sonQuery
        },{
        }).then(() => {
          this.onLoad();
          this.saveAndAddLoading=false;
          this.$message.success("新增成功!");
          // this.addClick(true);
          // done();
          let addform={};
          for (let i = 0; i < this.allOption.column.length; i++) {
            const element = this.allOption.column[i];
            if(element.value){
              addform[element.prop]=element.value;
            }
          }
          if(this.colObj.addProp){
            for (let index = 0; index < this.colObj.addProp.length; index++) {
              const ele = this.colObj.addProp[index];
              if(this.addType==='sub'||this.addType==='peer'){
                addform[ele]=this.addForm[ele];
              }
            }
          }
          addform[this.extendedProp.parent||'PARENT_ID']=this.addForm[this.extendedProp.parent||'PARENT_ID'];
          this.addForm=addform;
        }, err => {
          this.saveAndAddLoading=false;
          done();
        });
      } else {
        this.saveAndAddLoading=false;
        return false;
      }
    });
  },
  // 搜索
  searchChange(params,done) {
    for (const key in this.query) {
      if (Array.isArray(this.query[key])&key!=="highSearch") {
        this.query[key]=this.query[key].toString();
      }
    }
    this.page.currentPage = 1;
    this.onLoad();
    if (done){done()};
  },
  // 搜索清空
  searchReset() {
    this.query = {};
    this.onLoad();
  },
  // 页码
  currentChange(currentPage) {
    this.page.currentPage = currentPage;
    this.onLoad();
  },
  sizeChange(pageSize) {
    this.page.pageSize = pageSize;
    this.page.currentPage = 1;
    this.onLoad();
  },
  // 刷新
  refreshChange() {
    this.onLoad();
  },
  async sortChange(val){
    !!val.order && this.sortOrder == val.order? this.$refs.plxTree.clearSort():this.$refs.plxTree.sort(val.prop,this.sortOrder);
    this.sort={[`${val.order}s`]:val.prop};
    await this.onLoad();
    this.sortOrder = val.order;
    this.$refs.plxTree.sort(val.prop,val.order);
  },
  // 确定搜索筛选
  filterChange(result){
    let arr=[];
    for (let i = 0; i < result.length; i++) {
      const element = result[i];
      let obj={};
      obj.key=element[0];
      obj.condition=element[1];
      obj.value=element[2].toString();
      arr.push(obj);
    }
    this.query.highSearch=arr;
    this.onLoad();
  },
  ids() {
    let ids = {
      ids:[],
      ver:[],
    };
    this.$refs.plxTree.getCheckboxRecords().forEach(ele => {
      ids.ids.push(ele.ID);
      ids.ver.push(ele.DATA_VER);
    });
    return ids;
  },
  // 打开批量选择器
  openBatchSelector(obj){
    if(this.$refs.plxTree.getCheckboxRecords().length===0){
      this.$message.warning("请选择至少一条数据");
      return;
    };
    this.batch=obj;
    this.batchSelectorTemp=true;
    this.batchSelector=true;
  },
  sonQueryFn(){
    if(this.colObj.parentId){
      let parentIdArr=this.colObj.parentId.split(",");
      let parentIdObj={};
      for (let i = 0; i < parentIdArr.length; i++) {
        const parentId = parentIdArr[i];
        if(parentId in this.$route.query){
          parentIdObj[parentId]=this.$route.query[parentId];
        }
      }
      this.sonQuery=parentIdObj;
    }
  },
  // 加载table
  onLoad() {
    if(!this.$route.query.runId) return;
    this.loading = true;
    if(this.colObj.dataClass!==1&&this.colObj.dataClass){
      this.sonQueryFn();
    }
    if(this.dataObj){
      post(this.dataObj.url, this.$qs.stringify({
        runId:this.$route.query.runId,
        current:this.page.currentPage,
        size:this.page.pageSize,
        extendTreeType:this.allOption.extendTreeType||2,
        obj:JSON.stringify(objFilterEmpty({...this.query,...this.filterObj,...this.sonQuery})),
        ...this.dataObj.params,
      })).then(res => {
        this.loadFun(res,1);
      },err=>{
        this.loading = false;
      });
    }else{
      getShow(this.page.currentPage, this.page.pageSize,this.$route.query.runId,{
        extendTreeType:this.allOption.extendTreeType||2,
        obj:objFilterEmpty({...this.query,...this.filterObj,...this.sonQuery}),
        opid:this.colObj.opId,
        type:this.colObj.dataClass,
        ...this.loadObj,
        ...this.sort
      }).then(res => {
        this.loadFun(res,2);
      },err=>{
        this.loading = false;
      });
    }
  },
  // 递归方法
  recursion(records){
    for (let i = 0; i < records.length; i++) {
      records[i].HAS_CHILDREN=JSON.parse(records[i].HAS_CHILDREN || 'false');
      if(records[i].CHILDREN_LIST&&records[i].CHILDREN_LIST.length>0){
        this.recursion(records[i].CHILDREN_LIST);
      }
    }
  },
  async loadFun(res,type){
    console.log(res);
    const data = res.data.data;
    this.page.total = data.total;
    let records
    if(type===1){
      records=data;
    }else{
      records=data.records;
    }
    this.recursion(records);
    if(this.allOption.extendTreeType==1){
      this.data = records;
      this.$nextTick(()=>{
        this.$refs.plxTree.setAllTreeExpand(true);
      })
    }else{
      // 获取之前已经展开的
      let eExpand = this.$refs.plxTree.getTreeExpandRecords();
      console.log(eExpand,111);
      // 获取之前滚动的位置
      let scrollTop = this.$refs.plxTree.tableExample().scrollTop;
      // 删除完数据了，你可能需要重新载入数据
      console.log(eExpand);
      await this.$refs.plxTree.reloadData(records).then(() => {
        console.log(112)
        // 获取之前已经展开的
        // 在你重新reloadData后，因为是虚拟表格，树结构是不存在的，只有同级的概念，你看见的树其实是算法算出来的！
        // 所以在你重新赋值数据，你可能需要重新展开之前展开过的，且 this.$refs.plxTree.getTreeExpandRecords()方法
        // 需要在reloadData方法之前调用，然后把之前展开的用变量保存起来！
        // 遍历吧之前的展开回去
        // eExpand.forEach(row => {
        //   console.log(row);
        //   console.log(this.$refs.plxTree.setTreeExpand);
        //   // this.$refs.plxTree.toggleTreeExpand(row);
        //   // this.$refs.plxTree.setTreeExpansion(row, true);
          // this.$refs.plxTree.setAllTreeExpand(true);
        //   this.$refs.plxTree.setTreeExpand(row, true);
        // })
        this.$nextTick(() => {
          this.isRowExp(records,eExpand)
        })
        // 如果不调用滚动到之前的表格位置，那么你会感觉到当你重新赋值数据的时候，会滚动到顶部!
        // 注意树表格改变数据源滚动条滚动到顶部，你设置dataChangesScrollTop为false是一样滚动到顶部的，所以你还是用下面的方式滚动回去吧！
        // this.$refs.plxTree.pagingScrollTopLeft(scrollTop);
        // 好了是不是感觉虚拟树表格删除节点很简单啦？嘻嘻嘻！其实我并没有改表格代码，
        // 对于这样的功能都可以自己结合表格的方法自行实现！其实ux的树实现道理也是类似的！
      })
    }
    this.loading = false;
    this.selectionClear(); // 清除多选
  },
  async isRowExp(records,eExpand = []) {
    if(!this.colObj.firstOpen) return;
    let eIndex = records.findIndex(item => {
      return eExpand.some(it => it.ID == item.ID)
    })
    if(eIndex >= 0) {
      console.log(eExpand,eIndex,'e')
      if(eIndex >= 0) {
        let aa = await this.$refs.plxTree.setTreeExpand(records[eIndex], true);
        console.log(aa,records[eIndex],'aa')
        this.isRowExp(records[eIndex].CHILDREN,eExpand)
      }else {
        return;
      }
    }else{
      records.length && records[0]? await this.$refs.plxTree.setTreeExpand(records[0], true) : ''
    }
  },
  // 清除多选
  selectionClear() {
    this.$refs.plxTree.clearSelection();
  },
  // 过滤  数组 key 等于的值  return
  filterArrs(arr,key,value,re){
    if (!arr) return;
    let array=[];
    if(getObjType(value)!=='string') return;
    for (let index = 0; index < value.split(",").length; index++) {
      const id = value.split(",")[index];
      array.push(this.filterArr(arr,key,id,re));
    }
    return array.join(" | ");
  },
  filterArr(arr,key,value,re){
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      if(element[key]==value){
        return element[re];
      }
    }
  },
  // 开关事件
  switchClick(row,key,val){
    this.loading=true;
    updateShow({opid:this.colObj.opId,dataClass:this.colObj.dataClass,data:{
      ID:row.ID,
      [key]:val,
      DATA_VER:row.DATA_VER
    },runId:this.$route.query.runId,...this.sonQuery},{
    }).then(() => {
      this.onLoad();
      this.$message.success("操作成功!");
    }, err => {
      this.onLoad();
    });
  },
  // 颜色点击
  colorClick(method,row){
    if(method){
      this.$parent.$parent.$parent.$parent[method](row);
    }
  },
  // 获取选择器数据
  fn(param){
    console.log(param);
    this.selector=false;
    if(this.select.searchslotType==="search1"){
      Object.assign(this.query, param);
    }else if(this.filterCtrl) {
      this.filterData[this.filterIndex].value = param[this.selectorProp];
      this.filterData[this.filterIndex].$value = param[`$${this.selectorProp}`];
    }else{
      for (const key in param) {
        param[key]=param[key].toString();
      }
      if(this.select.searchslotType==="add"){
        Object.assign(this.addForm, param);
      }else{
        Object.assign(this.form, param);
      }
    }
  },
  // 获取选择器数据
  batchfn(param){
    this.batchSelector=false;
    if(param==="") return;
    for (const key in param) {
      if (Array.isArray(param[key])) {
        param[key]=param[key].toString();
      }
    }
    updateShow({
      opid:this.colObj.opId,
      dataClass:this.colObj.dataClass,
      data:{ID:this.ids().ids.join(","),DATA_VER:this.ids().ver.join(","),...param,...this.sonQuery},
      runId:this.$route.query.runId
    },{
    }).then(() => {
      this.onLoad();
      this.$message.success("操作成功!");
    }, err => {});
  },
  //增加过滤条件按钮
  addFilterCondition() {
    this.filterData.push({
      key: this.allOption.column[0].prop,
      condition: "=",
      value: ""
    })
  },
  //清空过滤条件按钮
  cleanFilterCondition() {
    this.filterData = [];
  },
  //清空数据按钮
  cleanFilterData() {
    this.filterData.forEach(item => {
      item.value = "";
    })
  },
  //改变过滤条件key需要清空对应的值
  filterKeyChange(index) {
    this.filterData[index].value = ""
    this.filterData[index].$value = ""
  },
  //过滤条件减少按钮
  filterReduce(item,index) {
    this.filterData.splice(index,1);
  },
  //增加过滤条件按钮
  filterSubmit(params){
    console.log(params);
    this.filterCtrl=false;
    this.query.highSearch=params;
    this.onLoad();
  },
  // 加载配置
  async configureFun(){
    if(!this.$route.query.runId) return;
    if(this.colObj.dataClass!==1&&this.colObj.dataClass){
      this.sonQueryFn();
    }
    try {
      let searchList=[];
      let configList = await configure({opid:this.colObj.opId,runId:this.$route.query.runId,type:this.colObj.dataClass,...this.colObj.configObj},{
      });
        // getShow(this.page.currentPage, this.page.pageSize,this.$route.query.runId,{
        //   // extendTreeType:this.allOption.extendTreeType||2,
        //   obj:objFilterEmpty({...this.query,...this.filterObj,...this.sonQuery}),
        //   opid:this.colObj.opId,
        //   type:this.colObj.dataClass,
        //   ...this.loadObj,
        //   ...this.sort
        // })
      const data=configList.data.data;
      let list=data.list
      let sortList=[];
      console.log(data.extendedProp,data.opDwProp);
      if(data.extendedProp){
        this.extendedProp=urlToObj(data.extendedProp);
      }
      if(data.opDwProp){
        this.extendedProp={...this.extendedProp,...urlToObj(data.opDwProp)};
      }
      console.log(this.extendedProp);
      if(data.button){
        let obj=JSON.parse(data.button);
        for (const key in obj) {
          if (obj[key]==="true") {
            obj[key]=true;
          }else if(obj[key]==="false") {
            obj[key]=false;
          }
        }
        this.buttonOption=obj;
      }
      if(data.standardButton){
        for (let i = 0; i < data.standardButton.length; i++) {
          const button = data.standardButton[i];
          this.avueOption[button.btnType]=true;
        }
      }
      for (let index = 0; index < list.length; index++) {
        let object=list[index];
        for (const key in object) {
          if (object[key]==="") {
            delete object[key];
          }else if(object[key]==="true"){
            object[key]=true;
          }else if(object[key]==="false"){
            object[key]=false;
          }
        }
        if(object.extendedProp){
          let obj=urlToObj(object.extendedProp);
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              const element = obj[key];
              object[key]=element;
            }
          }
          delete object.extendedProp;
        }
        if (object.dicUrl) object.urlType=object.dicUrl.split("&")[0].replace('type=',"");
        delete object.dicUrl;
        object.span=Number(object.span);
        object.labelWidth=object.formLabelWidth;
        if(object.type==="icon"){  //  icon
          object.iconList=iconList;
        }else if(object.type=="select"){  //下拉
          object.filterable=true;
        }else if(object.type=="selectDown"){  //下拉翻页
          object.selectData.selectData=object.selectData.selectData.filter(item=>{return item.hide!="true"}).slice(0,6);
        }else if(object.type=="slider"){  //滑动块
          object.min= Number(object.minRows);
          object.max= Number(object.maxRows);
          object.showStops= true;
          object.showInput= true;
          this.slider.push(object.prop);
        }
        if(object.rules){  //验证
          object.rules=JSON.parse(object.rules);
          if(object.rules[1].pattern===""&&object.rules[0].required==="false"){
            object.rules=[];
          }else if(object.rules[1].pattern===""&&object.rules[0].required!=="false"){
            object.rules.splice(1,1);
            if(object.rules[0].required==="true"){
              object.rules[0].required=true
            }else{
              object.rules[0].required=false
            }
          }else if(object.rules[1].pattern!==""&&object.rules[0].required==="false"){
            object.rules[1].pattern=strByReg(object.rules[1].pattern);
            object.rules.splice(0,1);
          }else{
            object.rules[1].pattern=strByReg(object.rules[1].pattern);
          }
        }
        if(object.type==="tableSelect"||object.type==="selectDown"||object.type==="association"||object.type==="toUpperCase"||object.type==="treeSelect"||object.type==="code"){
          sortList.push(object);
          object.formslot=true;
          object.labelslot=true;
          object.slot=true;
        }
        if(object.searchSpan){   // 搜索宽度
          object.searchSpan=Number(object.searchSpan);
        }
        if(this.colObj.col&&this.colObj.col.length>0){
          for (let i = 0; i < this.colObj.col.length; i++) {
            const element = this.colObj.col[i];
            if(element.key==object.prop){
              object.slot=true;
              this.dicData[object.prop+'Data']=object.dicData;
            }
          }
        }
        if(object.type.indexOf("cascadercheckboxuploadimgarraymapuploaddaterangedatetimerangetimerangedates")!=-1||(object.type.indexOf("selecttree")!=-1&&object.multiple==true)){
          object.dataType="string";   // 多选都用逗号分隔
        }
        if(object.hide===true){  //  隐藏
          this.hidColumnData.push(object.prop);
        }
        if(object.extendTreeType){
          object.selectData.properties.extendTreeType=object.extendTreeType;
        }
        object.overHidden=true;
        if(!object.dicData){
          object.dicData=[];
        }
        if(object.search){   //搜索配置
          let searchObj={};
          if("checkboxswitchselect".indexOf(object.type)!==-1||object.dicData.length>0){
            searchObj.type="select";
          }else if("associationtextarea".indexOf(object.type)!==-1){
            searchObj.type="input";
          }else if("datedatetime".indexOf(object.type)!==-1){
            searchObj.type="daterange";
          }else{
            searchObj.type=object.type;
          }
          if(object.searchSpan){   // 搜索宽度
            object.searchSpan=Number(object.searchSpan);
          }
          delete searchObj.rules;
          searchObj.prop=object.prop;
          searchObj.label=object.label;
          searchObj.dicData=object.dicData;
          searchObj.selectData=object.selectData;
          searchObj.selectSearch=object.selectSearch;
          searchObj.searchslotkey=object.searchslotkey;
          searchObj.searchslotid=object.searchslotid;
          searchObj.finderWhere=object.finderWhere;
          searchObj.codeTable=object.codeTable;
          searchObj.corField=object.corField;
          searchObj.searchslottitle=object.searchslottitle;
          searchObj.span=4;
          searchObj.tip=object.label;
          searchList.push(searchObj);
        }
        object.key=object.prop;
      }
      this.searchList=searchList;
      this.column=list;
      this.customSearch=sortList;
      this.topButton=data.topButton;
      // 数据 ↓
      this.onLoad();
      this.loading=false;
      // })
    } catch (e) {
      console.log(e);
      this.loading=false;
    }
  },
  // 获取表格最大高度
  tableHeightFn(){
    let height=document.getElementById("avue-view");
    if(height){
      if(height.clientHeight>=558){
        return height.clientHeight-208;
      }else{
        return 350
      }
    }
  }
},
created() {
  // console.log("配置");
  this.configureFun();
},
mounted() {},
activated() {},
}
</script>
<style lang='scss' scoped>
.hover{
  cursor: pointer;
}
.url{
  cursor: pointer;
  color: #2E5AE8;
}
.tree_template{
  /deep/.el-icon-folder-opened,/deep/.el-icon-folder{
    color: rgb(255, 192, 1) !important;
  }
  /deep/ .elx-tree--node-btn{
    &:hover{
      color: #2E5AE8;
      font-weight: bolder;
    }
    color: #2E5AE8;
    font-weight: bolder;
  }
  .ux-page{
    margin-top: 14px;
    height:32px;
    footer{
      float: right;
    }
  }
  /deep/ .elx-table .elx-cell {
    padding-left: 0;
    padding-right: 0;
  }
  /deep/.el-form-item__label {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
  }
  /deep/.el-form-item__content {
    margin: 0 2px !important;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
  }
  /deep/td {
    height: 32px !important;
  }
  /deep/.el-transfer-panel {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
    background: #FFF;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
  }
  .el-button span {
    margin-left: 0 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 0;
  /deep/.dialgForm{
    border: 1px solid rgb(135,184,230);
    background: rgb(241,250,255);
    /deep/.el-form-item{
      margin-bottom: 0;
    }
    /deep/.el-col{
      margin-bottom: 0;
      border-bottom: 1px solid rgb(135,184,230);
      border-right: 1px solid rgb(135,184,230);
      min-height: 30px;
      padding-top: 5px;
      padding-bottom: 5px;
      right: -1px;
      bottom: -1px;
    }
    /deep/ .el-form-item__error{
      margin-top: -22px;
      margin-right: 6px;
      right: 0;
      left: auto;
    }
  }
}
/deep/.el-transfer-panel__body {
  height: 100% !important;
}
/deep/.el-transfer-panel__list {
  padding-left: 15px !important;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  height: 100% !important;
  overflow: auto;
  box-sizing: border-box;
}
/deep/.el-transfer-panel__item {
  width: 100%;
  padding: 0px;
  height: 30px;
  line-height: 30px;
  display: block!important;
}
/deep/div.v-dropdown-caller.v-dropdown-caller--full-width{
  width: 100%;
}
.el-dropdown-link{
  color:  #2E5AE8;
}
</style>
<style>
.elx-table--tooltip-wrapper{
  z-index: 9999 !important;
}
</style>
